module.exports = __webpack_public_path__ + "images/branding/savemyhomeusa/right_tab.gif";